import FrenchFlagIcon           from '@/assets/icons/FrenchFlagIcon';
import JapanFlagIcon            from '@/assets/icons/JapanFlagIcon';
import UnitedKingdomFlagIcon    from '@/assets/icons/UnitedKingdomFlagIcon';

interface IFlagIconProps {
	languageKey: LanguageKey
}

const FlagIcon = (props: IFlagIconProps) => {

	const { languageKey } = props;

	switch (languageKey) {
		case 'fr':
			return <FrenchFlagIcon fontSize="40px" />;

		case 'en':
			return <UnitedKingdomFlagIcon fontSize="40px" />;

		case 'jp':
			return <JapanFlagIcon fontSize="40px" />;
	} 
}

export default FlagIcon;